import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import about from '@/components/about'
import about_company from '@/components/about_company'
import about_media from '@/components/about_media'
import cooperation from '@/components/cooperation'
import recruitment from '@/components/recruitment'
import experience from '@/components/experience'
import media_content from '@/components/media_content'
import privacy from '@/components/privacy'
import terms from '@/components/terms'
import icp from '@/components/icp'
import privacyNt from '@/components/privacy_nt'
import termsNt from '@/components/terms_nt'
import cpInfo from '@/components/cp_info.vue'
import product from '@/components/product.vue'
import dxPrivacy from '@/components/dx-privacy.vue'
import dxTerms from '@/components/dx-terms.vue'

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', name: 'home', component: index },
    { path: '/index', name: 'index', component: index },
    {
      path: '/about',
      name: 'about',
      component: about,
      children: [
        {
          path: '',
          name: 'about_home',
          component: about_company
        },
        {
          path: 'company',
          name: 'company',
          component: about_company
        },
        {
          path: 'media',
          name: 'media',
          component: about_media
        },
        {
          path: 'cooperation',
          name: 'cooperation',
          component: cooperation,
          redirect: '/cooperation'
        },
        {
          path: 'mediaContent',
          name: 'mediaContent',
          component: media_content
        }
      ]
    },
    { path: '/experience', component: experience },
    { path: '/recruitment', component: recruitment },
    { path: '/cooperation', name: 'cooperation', component: cooperation },
    { path: '/privacy', name: 'privacy', component: privacy },
    { path: '/terms', name: 'terms', component: terms },
    { path: '/icp', name: 'icp', component: icp },
    { path: '/privacy_nt', name: 'privacy_nt', component: privacyNt },
    { path: '/terms_nt', name: 'terms_nt', component: termsNt },
    { path: '/cp_info', name: 'cp_info', component: cpInfo },
    { path: '/product', name: 'product', component: product},
    { path: '/privacy/dxdzz', name: 'dx-privacy', component: dxPrivacy},
    { path: '/terms/dxdzz', name: 'dx-terms', component: dxTerms}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js